var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-end"},[_c('input',{staticClass:"mr-2",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"click":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',{staticClass:"caption"},[_vm._v("Confirm "+_vm._s(_vm.customYear)+" Year Rate")])])
}
var staticRenderFns = []

export { render, staticRenderFns }